import { STORAGE_ACCESS_TOKEN, STORAGE_ACTIVE_MEETING_ID, STORAGE_DELETION_CANCELLED, STORAGE_USER_PROFILE } from './constants';
import logger from './logger';
/**
 * 读取门户 accessToken。
 */
export function getAccessToken() {
    try {
        return localStorage.getItem(STORAGE_ACCESS_TOKEN);
    }
    catch (e) {
        logger.warn(`读取 accessToken 失败 | ${e?.message}`);
        return null;
    }
}
/**
 * 保存登录会话。
 */
export function saveSession(accessToken, user) {
    localStorage.setItem(STORAGE_ACCESS_TOKEN, accessToken);
    localStorage.setItem(STORAGE_USER_PROFILE, JSON.stringify(user));
    logger.info(`已保存门户会话 | userId=${user.id}`);
}
/**
 * 清除会话。
 */
export function clearSession() {
    localStorage.removeItem(STORAGE_ACCESS_TOKEN);
    localStorage.removeItem(STORAGE_USER_PROFILE);
    logger.info('已清除门户会话');
}
/**
 * 读取本地用户资料。
 */
export function getStoredUser() {
    try {
        const raw = localStorage.getItem(STORAGE_USER_PROFILE);
        if (!raw) {
            return null;
        }
        return JSON.parse(raw);
    }
    catch {
        return null;
    }
}
/**
 * 登录成功且取消了冷静期注销时写入，首页读取后清除。
 */
export function markDeletionCancelled() {
    try {
        sessionStorage.setItem(STORAGE_DELETION_CANCELLED, '1');
        logger.info(`[账号] ${new Date().toISOString()} 标记已取消注销`);
    }
    catch (e) {
        logger.warn(`标记取消注销失败 | ${e?.message}`);
    }
}
/**
 * 读取并清除「已取消注销」标记。
 */
export function consumeDeletionCancelled() {
    try {
        if (sessionStorage.getItem(STORAGE_DELETION_CANCELLED) !== '1') {
            return false;
        }
        sessionStorage.removeItem(STORAGE_DELETION_CANCELLED);
        logger.info(`[账号] ${new Date().toISOString()} 已消费取消注销提示`);
        return true;
    }
    catch (e) {
        logger.warn(`读取取消注销标记失败 | ${e?.message}`);
        return false;
    }
}
/**
 * 入会时写入当前门户会议 ID（sessionStorage）。
 *
 * @param {number} meetingId - 门户会议主键
 * @returns {void}
 */
export function saveActiveMeetingId(meetingId) {
    try {
        sessionStorage.setItem(STORAGE_ACTIVE_MEETING_ID, String(meetingId));
        logger.info(`已保存会中 meetingId | meetingId=${meetingId}`);
    }
    catch (e) {
        logger.warn(`保存 meetingId 失败 | ${e?.message}`);
    }
}
/**
 * 读取会中门户会议 ID。
 *
 * @returns {number | null}
 */
export function getActiveMeetingId() {
    try {
        const raw = sessionStorage.getItem(STORAGE_ACTIVE_MEETING_ID);
        if (!raw) {
            return null;
        }
        const id = Number(raw);
        return Number.isFinite(id) && id > 0 ? id : null;
    }
    catch (e) {
        logger.warn(`读取 meetingId 失败 | ${e?.message}`);
        return null;
    }
}
/**
 * 清除会中门户会议 ID。
 *
 * @returns {void}
 */
export function clearActiveMeetingId() {
    try {
        sessionStorage.removeItem(STORAGE_ACTIVE_MEETING_ID);
        logger.info('已清除会中 meetingId');
    }
    catch (e) {
        logger.warn(`清除 meetingId 失败 | ${e?.message}`);
    }
}
